
<script setup>

import {inject} from 'vue'
import DateInformationTooltip from "@/components/common/other/DateInformationTooltip.vue";
import GridCellDetail from "@/components/common/other/GridCellDetail.vue";
import Table from "@/components/common/other/Table.vue";

const shipments = inject("shipments");

function getCorrectDate(date) {

  if (date.actual === '') return date.est
  return date.actual
}

</script>



<template class="cmp-detailed-information">
  <div class="cmp-detailed-information_wrapper">
    <div class="cmp-detailed-information_container">
      <div class="cmp-detailed-information_date-wrapper">
        <div v-for="item in shipments.viewShipment.milestoneInformation.dateColumns"
             class="cmp-detailed-information_milestone-dates">
          <div class="label">{{ item.title }}</div>
          <div v-for="data in shipments.viewShipment.milestoneInformation.dates">
            <GridCellDetail
                :notGridCell="true"
                v-model:cellColor="data[item.key].status">
              <template #details>
                <DateInformationTooltip
                    :estDate="data[item.key].est"
                    :estTime="data[item.key].estimatedTime"
                    :actualDate="data[item.key].actual">
                </DateInformationTooltip>
              </template>
              <template #cell-data>
                <div class="cmp-detailed-information_date-data">{{ getCorrectDate(data[item.key]) }}</div>
              </template>
            </GridCellDetail>
          </div>
        </div>
      </div>
      <Table
          style="margin-top: 10px"
          :key=" shipments.viewShipment.milestoneInformation.milestones.length"
          :allowGridMenu="false"
          :selectable="false"
          :row-selection="false"
          height="110"
          :dataSource="shipments.viewShipment.milestoneInformation.milestones"
          :columns="shipments.milestoneColumns">
      </Table>
    </div>
  </div>

</template>

<style lang="scss" scoped>

.cmp-detailed-information {

  &_wrapper {
    font-size: 12px;
    height: 200px;
  }

  &_date-wrapper {
    display: flex;
    gap: 22px;
    background: #f1efec;
    border-radius: 14px;
    height: 38px;
    padding-left: 10px;
  }

  &_milestone-dates {
    font-size: 12px;
    display: flex;
    flex: none;
    align-items: center;
    padding-left: 5px;
    gap: 8px;
  }

  &_date-data {
    display: flex;
    align-items: center;
    align-content: center;
    height: 26px;
    overflow: hidden;
  }

}

</style>
